import dayjs from "dayjs";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export const ExtendDialog = ({ booking, value, setValue, busy, onConfirm, onClose }) => (
  <Dialog open={!!booking} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="extend-dialog">
      <DialogHeader>
        <DialogTitle className="heading-upper text-[#144733]">Extend {booking?.booking_ref}</DialogTitle>
      </DialogHeader>
      {booking?.mode === "monthly" ? (
        <div>
          <label className="field-label">Additional months</label>
          <select className="field-input" value={value} onChange={(e) => setValue(e.target.value)} data-testid="extend-months-select">
            {[1, 2, 3, 6].map((m) => <option key={m} value={m}>{m} month{m > 1 ? "s" : ""}</option>)}
          </select>
        </div>
      ) : (
        <div>
          <label className="field-label">New return date & time</label>
          <input type="datetime-local" className="field-input" value={value}
            min={booking ? dayjs(booking.return_datetime).format("YYYY-MM-DDTHH:mm") : undefined}
            onChange={(e) => setValue(e.target.value)} data-testid="extend-return-input" />
          <p className="text-[11px] text-[#8a978f] mt-2">Short-term rentals max 21 days total. Price recalculates automatically.</p>
        </div>
      )}
      <button onClick={onConfirm} disabled={busy} className="btn-cta rounded w-full py-3 text-xs mt-2" data-testid="extend-confirm-btn">
        {busy ? "Updating…" : "Confirm extension"}
      </button>
    </DialogContent>
  </Dialog>
);
